<template>
    <div>
        <div class="pull-right">
            <a :href="csvExportUrl" class="btn btn-link is-aligned-right" style="font-weight: normal">
                <span class="glyphicon glyphicon-list-alt" aria-hidden="true"></span> Export to CSV</a>
        </div>
        <h2>Leads Quality</h2>
        <div class="row filters-panel">
            <div class="col-md-3 col-lg-3">
                <h2 class="h5 h-aside is-toggable-mobile">
                    Grouping
                </h2>
                <div class="filter-links">
                        <a :class="{active: period == 'monthsToDate'}" :href="url('monthsToDate')">Month to Date</a>
                        <a :class="{active: period == 'months'}" :href="url('months')">Month</a>
                        <a :class="{active: period == 'weeks'}" :href="url('weeks')">Week</a>
                        <a :class="{active: period == 'days'}" :href="url('days')">Days</a>
                        <a :class="{active: period == 'states'}" :href="url('states')">States</a>
                </div>
            </div>
            <div class="col-md-4 col-lg-4">
            </div>
            <div class="col-md-3 col-lg-3">
                <h2 class="h5 h-aside is-toggable-mobile">
                    Range
                </h2>
                <div class="filter-links">
                    <a :class="{active: range == 'last3Months'}" :href="url(null, 'last3Months')">Last 3 Months</a>
                    <a :class="{active: range == 'lastYear'}" :href="url(null, 'lastYear')">Last Year</a>
                    <a :class="{active: range == 'custom'}" @click="openCustomDateFilter()">Custom</a>
                </div>
            </div>
            <div class="col-md-2 col-lg-2">
                <h2 class="h5 h-aside is-toggable-mobile">
                    Lead Type
                </h2>
                <div class="filter-links">
                    <a :class="{active: appType == 'all'}" @click="appType='all'" style="cursor: pointer">All</a>
                    <a :class="{active: appType == 'mc'}" @click="appType='mc'" style="cursor: pointer">MC</a>
                    <a :class="{active: appType == 'mc_optin'}" @click="appType='mc_optin'" style="cursor: pointer">MC opt-in</a>
                    <a :class="{active: appType == 'direct'}" @click="appType='direct'" style="cursor: pointer">Direct</a>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="table-responsive">

                <table class="table table-striped table-hover column-lines">
                <tbody>
                    <tr>
                        <th>
                            <div style="display: flex">
                                <a :href="url(null, range, 'paid_media_source')" class="btn btn-info" style="margin: 0 0.5rem 0.5rem 0">Source</a>
                                <a :href="url(null, range, 'trsource')" class="btn btn-info" style="margin: 0 0.5rem 0.5rem 0">Trsource</a>

                                <div class="btn-group">
                                    <button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="margin: 0 0.5rem 0.5rem 0">
                                        UTM <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li><a :href="url(null, range, 'utm_source')">UTM source</a></li>
                                        <li><a :href="url(null, range, 'utm_medium')">UTM medium</a></li>
                                        <li><a :href="url(null, range, 'utm_campaign')">UTM campaign</a></li>
                                    </ul>
                                </div>
                            </div>

                            <template v-if="expandedViewOnly === false">
                                <button @click="sourcesExpanded=!sourcesExpanded" class="btn btn-secondary">
                                    <template v-if="sourcesExpanded">
                                        Hide Sources
                                    </template>
                                    <template v-else>
                                        Show Sources
                                    </template>
                                </button>
                            </template>

                        </th>

                        <th v-for="at in driverTypeColumns" :colspan="getDriverTypeColspan" class="primary-separator">
                            {{ getDriverTypeColumnName(at.key) }}
                        </th>
                    </tr>

                    <tr>
                        <th>Group</th>

                        <template v-for="group in driverTypeColumns">
                            <th v-for="(tt, ttIndex) in trafficColumns" :class="{ 'primary-separator': ttIndex === 0, 'secondary-separator': ttIndex > 0 }" :colspan="getTrafficTypeColspan(tt)">
                                {{ getTrafficTypeColumnName(tt) }}
                            </th>
                        </template>
                    </tr>

                    <tr v-if="sourcesExpanded">
                        <th></th>

                        <template v-for="at in driverTypeColumns">
                            <template v-for="(tt, ttIndex) in trafficColumns">
                                
                                <th v-for="(source, sourceIndex) in tt.sources" :class="{ 'primary-separator': ttIndex === 0 && sourceIndex === 0, 'secondary-separator': ttIndex > 0 && sourceIndex === 0, 'icon': source.icon }">
                                    <template v-if="source.icon">
                                        <i :class="source.icon"></i>
                                    </template>
                                    <template v-else-if="source.name === ''">
                                        <i>none</i>
                                    </template>
                                    <template v-else>
                                        {{ source.name }}
                                    </template>
                                </th>
                            </template>

                            <th class="secondary-separator"></th>
                        </template>
                    </tr>

                    <tr class="table-values" v-for="(row, key, index) in formattedRows">
                        <td class="text-left">{{key}} <span v-show="index==0 && period != 'states'">- (in progress)</span></td>

                        <template v-for="at in driverTypeColumns">
                            <template v-for="(tt, ttIndex) in trafficColumns">

                                <!-- Collapsed view (always for "Total" column) -->
                                <template v-if="sourcesExpanded == false || (sourcesExpanded == true && tt.total)">
                                    <td :class="{ 'primary-separator': ttIndex === 0, 'secondary-separator': ttIndex > 0 }">
                                        {{ getValue(row, tt.sumKeys, at.sumKeys) }}
                                    </td>
                                </template>
                                <template v-else>
                                <!-- Expanded view (all trafficColumns except for "Total" are replaced by their sources) -->
                                    <td v-for="(source, sourceIndex) in tt.sources" :class="{ 'primary-separator': ttIndex === 0 && sourceIndex === 0, 'secondary-separator': ttIndex > 0 && sourceIndex === 0 }">
                                        {{ getValue(row, source.key, at.sumKeys) }}
                                    </td>
                                </template>

                            </template><!-- /trafficColumns -->
                        </template><!-- /driverTypeColumns  -->

                    </tr>
                </tbody>
                </table>

            </div>
        </div>

<!-- dialog - custom dates-->
<el-dialog title="Custom Date Filter"
           :close-on-click-modal="false"
           :visible.sync="showCustomDateFilter"
           width="350px">

            <div class="form-group">
                <label>From</label>
                <div>
                    <el-date-picker v-model="from" type="date" placeholder="Pick a day" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
            </div>
            <div class="form-group">
                <label>To</label>
                <div>
                    <el-date-picker v-model="to" type="date" placeholder="Pick a day" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
            </div>

    <span slot="footer" class="dialog-footer">
        <el-button @click="showCustomDateFilter = false">Close</el-button>
        <el-button type="primary" @click="applyCustomDateFilter">Apply Filter</el-button>
    </span>
</el-dialog>

    </div>
</template>

<script>
    export default {
        props: [
            'data'
        ],
        data() {
            return {
                formattedRows: [],
                period: 'monthsToDate',
                range: 'last3Months',
                sourceType: this.data.sourceType,
                activeMetric: 'appsCount',
                sourcesExpanded: false,
                appType: 'all',

                driverTypeColumns: this.data.driverTypeColumns,
                trafficColumns: this.data.trafficColumns,

                // custom date range dialog
                showCustomDateFilter: false,
                from: null,
                to: null
            }
        },
        computed:{
            csvExportUrl() {
                return url('admin/reports/lead-quality-apps/csv?source_type=' + this.sourceType);
            },
            getDriverTypeColspan() {
                if(this.sourcesExpanded === true) {
                    let columns = 0;
                    _.forEach(this.trafficColumns, (tt) => {
                        columns += tt.sources.length;
                    });

                    return columns + 1; // +1 for Total column
                }

                return this.trafficColumns.length;
            },

            // If only 1 non total traffic column is present, show only expanded view and hide toggle button
            getNonTotalTrafficTypeCount() {
                let isTotal = _.filter(this.trafficColumns, ['total', true]).length;

                return this.trafficColumns.length - isTotal;
            },
            expandedViewOnly() {
                if(this.getNonTotalTrafficTypeCount == 1) {
                    this.sourcesExpanded = true;

                    return true;
                }

                return false;
            },
        },
        methods: {
            url(period, range, sourceType) {
                if(!range){
                    range = this.range;
                }
                if(!period){
                    period = this.period;
                }
                if(!sourceType){
                    sourceType = this.sourceType;
                }

                let fromPart = this.from ? `&from=${this.from}` : '';
                let toPart = this.to ? `&to=${this.to}` : '';
                return url('admin/reports/lead-quality-apps?source_type=' + sourceType + '&period=' + period + '&range=' + range + fromPart + toPart);
            },
            initializeTableData(){
                this.formattedRows = _.cloneDeep(this.data.rows);
                this.period = this.data.period;
                this.range = this.data.range;
                this.from = this.data.from;
                this.to = this.data.to;
            },
            sumSources(row, sources, xp, key){

                let keys = this.getXpsValues(xp, key, this.appType);
                let sum = 0;
                _.forEach(keys, (k) => {
                    _.forEach(sources, (s) => {
                            sum += row[s] ? parseFloat(row[s][k]) : 0;
                    });
                });
                return sum;
            },
            getValue(row, sourceKeys, xp, format = true){
                let selectedSourceKeys = this.formatSourceKeys(sourceKeys);

                let v = null;
                switch (this.activeMetric) {
                    case 'appsCount':
                        v = this.sumSources(row, selectedSourceKeys, xp, 'app_count');
                        return  format ? this.usNum(v) : v;

                    case 'totalCost' :
                        v = this.sumSources(row, selectedSourceKeys, xp, 'cost');

                        return format && v ? '$' + this.money(v, 0) : v;

                    case 'avgAmt' :
                        let count = this.sumSources(row, selectedSourceKeys, xp, 'app_count');
                        let cost = this.sumSources(row, selectedSourceKeys, xp, 'cost');
                        v = (count > 0) ? cost / count : 0;
                        return format && v ? '$' + this.money(v, 0) : v;

                    case 'avgEmp' :
                        let appCount = this.sumSources(row, selectedSourceKeys, xp, 'app_count');
                        let empCount = this.sumSources(row, selectedSourceKeys, xp, 'emp_count');
                        //return empCount+ '/' + appCount
                        v = (appCount > 0) ? empCount/appCount : 0;
                        return format && v ? this.usNum(v) : v;
                }
            },

            getXpsValues(input, sufix, appType){
                if(!Array.isArray(input)){
                    input = [input];
                }

                let at = appType + '_';
                if (appType === 'all') {
                    at = ''
                }

                let result = [];
                _.forEach(input, (i) => {
                    result.push(at + i + '_' + sufix);
                });
                return result;
            },
            formatSourceKeys(sourceKeys) {
                if(!Array.isArray(sourceKeys)){
                    sourceKeys = [sourceKeys];
                }

                return sourceKeys;
            },
            getDriverTypeColumnName(key) {
                if(key == 'all' && this.appType != 'mc') {
                    return 'All (including conversions)';
                } else {
                    return _.find(this.driverTypeColumns, { 'key': key }).name;
                }
            },
            getTrafficTypeColumnName(tt) {
                if(! tt.total) {
                    return tt.name;
                }

                if(this.activeMetric == 'appsCount' || this.activeMetric == 'totalCost') {
                    return 'Total';
                }
                return 'Avg';
            },
            getTrafficTypeColspan(tt) {
                if(this.sourcesExpanded === true) {
                    if(! tt.total) {
                        return tt.sources.length == 0 ? 1 : tt.sources.length;
                    }
                }

                return 1;
            },

            // custom date filter
            openCustomDateFilter() {
                this.showCustomDateFilter = true;
            },
            applyCustomDateFilter() {
                window.location.href = this.url(null, 'custom');
            }
        },
        watch: {
            activeMetric(){
                this.$forceUpdate();
            }
        },
        mounted(){
            this.initializeTableData();
            $('[data-toggle="tooltip"]').tooltip();
        }
    }
</script>

<style scoped>
    .filter-links a {
        margin: 0 10px 0 0;
    }
    .filter-links.value-filter a {
        margin: 0 8px 0 0;
    }
    .filter-links.value-filter a .glyphicon {
        margin-left: 0;
    }
    .filters-panel {
        margin-bottom: 20px;
    }
    .column-lines {
        border: 1px solid #EEEEEE;
    }
    .column-lines th,
    .column-lines td {
        border-left: 2px solid #EEEEEE;
    }
    .active {font-weight: bold}

    th.primary-separator,
    td.primary-separator{
        border-left: 2px solid slategray;
    }

    th.secondary-separator,
    td.secondary-separator{
        border-left: 2px solid #DDDDDD;
    }
    .table-values {
        text-align: right;
    }

    .glyphicon-info-sign{
        margin-left: 5px;
    }

    th.icon {
        font-size: 19px;
        text-align: center;
    }
</style>
